import { Plugin } from '@tiptap/pm/state';
import { isObject, isString } from 'lodash';

/**
 * Tiptap suffixes the keys with a number to indentify the number of the instance,
 * so we are using `startWith` to check if the name matches.
 */
export function assertPluginKey(plugin: Plugin, key: string) {
  const startsWithGivenKey =
    isObject(plugin.spec.key) &&
    'key' in plugin.spec.key &&
    isString(plugin.spec.key['key']) &&
    // @TODO remove this cast when we upgrade Typescript to >5.0;
    (plugin.spec.key['key'] as string).startsWith(key);

  if (!startsWithGivenKey) {
    throw new Error(`Plugin key doesn't match the given key`);
  }
}
